import clsx from 'clsx'
import Bard from '../../components/bard/Bard'
import { PageInfo } from '@/src/@types/models'
import { FlchContentWithImageBlock } from '@/src/@types/statamic'
import Picture from '@/src/components/elements/Picture'
import Container from '@/src/components/layout/Container'

export default function FlchContentWithImage({
  content,
  image,
  image_side,
  pageInfo,
}: FlchContentWithImageBlock & { pageInfo: PageInfo }) {
  const imageOnLeft = image_side?.value === 'left'

  return (
    <Container
      className={clsx({
        'mt-20 md:mt-32': pageInfo.newSpacing,
      })}
    >
      <div className="grid gap-8 lg:grid-cols-2 lg:gap-14">
        <div
          className={clsx('flex flex-col justify-center', {
            'lg:order-2': imageOnLeft,
          })}
        >
          <Bard content={content} fullWidth pageInfo={pageInfo} />
        </div>
        {image && (
          <div
            className={clsx(
              'relative order-first aspect-3/2 overflow-hidden rounded-2xl lg:aspect-auto lg:min-h-125',
              {
                'lg:order-1': imageOnLeft,
                'lg:order-0': !imageOnLeft,
              }
            )}
          >
            <Picture
              {...image}
              fill
              sizes="(min-width: 1024px) 50vw, 100vw"
              className="object-cover"
            />
          </div>
        )}
      </div>
    </Container>
  )
}
